<template>
    <div>
        <input type="hidden"  name="" ref="jcrop">
        <input type="hidden" v-model="content.JcropH" :name="'JcropH['+ index +']'">
        <input type="hidden" v-model="content.JcropW" :name="'JcropW['+ index +']'">
        <input type="hidden" v-model="content.JcropY" :name="'JcropY['+ index +']'">
        <input type="hidden" v-model="content.JcropX" :name="'JcropX['+ index +']'">
        
    </div>
</template>

<script>
export default {

  name: 'jcropValues',
  props: {
    value:  {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
        content: this.value
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.content = newVal
    }
  },
  methods: {
      handleInput (e) {
          this.$emit('input', this.content)
      }
  }
};
</script>

<style lang="css" scoped>
</style>
